import { motion } from "motion/react";
import { Compass } from "lucide-react";
import { useNavigate } from "react-router";

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-[70vh] flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="text-center max-w-md px-6"
      >
        <Compass size={36} className="text-accent/40 mx-auto mb-4" />
        <h1
          className="text-primary mb-2"
          style={{
            fontFamily: "'Fraunces', Georgia, serif",
            fontSize: "1.6rem",
            fontWeight: 400,
          }}
        >
          Lost in thought
        </h1>
        <p
          className="text-muted-foreground mb-6"
          style={{ fontSize: "0.9rem", lineHeight: "1.6" }}
        >
          This page doesn't exist yet. Head back home and drop a thought.
        </p>
        <button
          onClick={() => navigate("/")}
          className="px-5 py-2.5 rounded-xl bg-accent text-accent-foreground transition-all hover:opacity-90"
          style={{ fontSize: "0.88rem" }}
        >
          Go Home
        </button>
      </motion.div>
    </div>
  );
}
